module.exports = __webpack_public_path__ + "img/FilipePortela.5ed2b1cd.png";